module.exports = __webpack_public_path__ + "img/21_85.13a22d27.png";